var path = 'src/app/components/technical/tooltip/tooltip.template.html';
var html = "<div ng-transclude=\"wrapper\"></div>\n<div ng-transclude=\"body\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;